import {Injectable} from "@angular/core";
import {jwtDecode} from "jwt-decode";
import {SECONDS_TO_MILLISECONDS_FOR_CONVERTING_JS_DATE} from "../constants/global.constants";

@Injectable({
  providedIn: "root",
})
export class TokenUtil {

  getJwtTokenExpirationTimestamp(jwtToken: string) {
    const decodedJwtToken: any = jwtDecode(jwtToken);
    const jwtTokenExpirationTimestamp = decodedJwtToken.exp;
    return new Date(jwtTokenExpirationTimestamp * SECONDS_TO_MILLISECONDS_FOR_CONVERTING_JS_DATE);
  }
}
